import { createAsyncThunk } from '@reduxjs/toolkit';
import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { mapEveryBigintIntoNumber } from 'utils/map-every-bigint-into-number';
import {
    ThirdPartyFulfillmentSettingsResponse,
    ThirdPartyFulfillmentSettingsResponseSchema,
} from '../../../../pb/responses/v1/third_party_fulfillment_settings_response_pb';

export const getThirdPartyFulfillmentSettings = createAsyncThunk<ThirdPartyFulfillmentSettingsResponse>(
    '[thirdPartyFulfillmentSettings] getThirdPartyFulfillmentSettings',
    async () => {
        const pbClient = new ProtobufClient(goBackendApi());
        return await pbClient
            .getRequest(ThirdPartyFulfillmentSettingsResponseSchema, '/api/v1/settings/third-party-fulfillment')
            .then((response) => {
                return mapEveryBigintIntoNumber(response) as ThirdPartyFulfillmentSettingsResponse;
            });
    }
);
